import { hasKycErrors } from 'commons/utils/getKycError';
import { useIdentityValidation } from './useIdentityValidation';
import { useProofOfLifeUrl } from './useProofOfLifeUrl';

export default function useShowProofOfLifeErrorAlert() {
  const idValidation = useIdentityValidation();

  const { hasProofOfLifeError } = hasKycErrors(
    idValidation.data?.kycDocumentErrors ?? [],
  );
  const showProofOfLifeErrorAlert = Boolean(
    hasProofOfLifeError && idValidation.data?.status === 'active',
  );

  const { proofOfLifeUrl, isLoading: isProofOfLifeUrlLoading } =
    useProofOfLifeUrl({
      enabled: showProofOfLifeErrorAlert,
    });

  if (!idValidation.data)
    return {
      show: false,
    };

  return {
    show: showProofOfLifeErrorAlert,
    proofOfLifeUrl,
    // The alert's CTA is the url: without it there is nothing to open, so the
    // component needs to tell a pending fetch apart from one that gave up.
    isProofOfLifeUrlLoading,
    errorCode: idValidation.data.kycDocumentErrors.find(
      (documentError) => documentError.documentName === 'proof_of_life',
    )?.errorCode,
  };
}
